// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__soOeO","row":"ProcedureTreatmentSummary_row__1ke1_"};